export default "__VITE_ASSET__DrdGyswe__"